var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotelSolid = function SvgHotelSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7a.75.75 0 0 0-1.5 0v11a.75.75 0 0 0 1.5 0v-3.25h16.5V18a.75.75 0 0 0 1.5 0v-8A2.75 2.75 0 0 0 19 7.25h-8a.75.75 0 0 0-.75.75v5.25h-6.5V7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "currentColor"
  })));
};
export default SvgHotelSolid;